export const config = {
    BASE_PATH: "/overcut/api",
    SERVICE_TOKEN_NAME: "serviceToken"
}
